import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { rgba } from 'polished';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const ChangeStatusBox = styled.span`
  display: inline-block;
  padding: 5px 16px;
  margin-left: 5px;
  ${TYPOGRAPHY.button}
  border-radius: 2px;
  text-transform: uppercase;
  color: ${props => props.color};
  background-color: ${props => (rgba(props.color, 0.12))};
`;

ChangeStatusBox.propTypes = {
  color: PropTypes.oneOf([COLORS.success, COLORS.error, '#fff']).isRequired,
};

export default ChangeStatusBox;
